<template>
  <div class="tw-bg-white tw-rounded-lg tw-shadow-smx tw-border tw-overflow-hidden tw-border-gray-200">
    <table class="tw-min-w-full tw-leading-normal">
      <thead>
        <tr>
          <th v-for="column in columns" :key="column.name"
            :class="column.classes"
            class="tw-px-5 last:tw-border-e-0 tw-whitespace-nowrap tw-border-e tw-py-3 tw-border-b tw-border tw-border-gray-100 tw-bg-gray-50 tw-text-start tw-text-[12px] tw-font-semibold tw-text-gray-600 tw-uppercase tw-tracking-wider"
          >
            {{ $t(column.label) }}
          </th>
        </tr>
      </thead>
  
      <tbody v-if="loading">
        <tr class="tw-border-b tw-border-solid tw-border-gray-100 last:tw-border-b-0 tw-group even:tw-bg-gray-50/50" v-for="i in 10" :key="i">
          <td v-for="column in columns" :key="column.name" class="tw-px-5 tw-py-3">
            <div class="tw-w-full tw-py-3 tw-bg-gray-50 group-even:tw-bg-white tw-rounded tw-min-w-[30px] tw-animate-pulse">
            </div>
          </td>
        </tr>
      </tbody>

      <tbody v-else>
        <template v-if="items.length > 0">
          <AdminProductTableRow 
            v-for="product in items" 
            :key="product.id" 
            :item="product" 
            @edit="$emit('edit', product)"
            @delete="$emit('delete', product)"
          />
        </template>
        <template v-else>
          <tr>
            <td :colspan="columns.length">
              <div class="tw-p-5 tw-bg-white tw-min-h-[250px] tw-text-gray-600 tw-flex tw-items-center tw-justify-center tw-text-lg">
                <p>{{ $t('messages.table-no-results') }}</p>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>

  <div class="tw-my-4"></div>

  <TablePagination 
    v-if="items.length > 0" 
    :has-next="!!options.next_page_url" 
    :has-previous="!!options.prev_page_url" 
    @previous="$emit('previous')" 
    @next="$emit('next')" 
  />
</template>

<script setup>
import { ref, defineProps, defineEmits } from 'vue'
import TablePagination from '@/components/table/TablePagination.vue'
import AdminProductTableRow from './AdminProductTableRow.vue'

defineProps({
  loading: {
    type: Boolean,
    default: false
  },
  items: {
    type: Array,
    default: () => []
  },
  options: {
    type: Object,
    default: () => ({})
  }
});

defineEmits(['next', 'previous', 'edit', 'delete'])

const columns = ref([
  { name: 'id', label: 'fields.id', classes: ['tw-w-[80px]'] },
  { name: 'image', label: 'fields.image', classes: ['tw-w-[100px]'] },
  { name: 'name', label: 'fields.name', classes: ['tw-min-w-[200px]'] },
  { name: 'description', label: 'fields.description', classes: ['tw-min-w-[250px]'] },
  { name: 'categories', label: 'fields.categories', classes: ['tw-w-[180px]'] },
  { name: 'company', label: 'fields.company', classes: ['tw-w-[200px]'] },
  { name: 'created', label: 'fields.created', classes: ['tw-w-[120px]'] },
  { name: 'actions', label: 'fields.actions', classes: ['tw-w-[120px]'] },
])
</script>

<style scoped>
/* Add any custom styles here */
</style> 